const config = {
  appUrl: 'http://localhost:3000',
  serverUrl: 'https://apluspatient-server-dev.azurewebsites.net',
  authToken: 'bearer '
};

export default config;
